import React, { useState, useEffect } from "react"
import ReactPaginate from 'react-paginate';

function Post(props) {
    const { data } = props;

    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 6;
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
    };

    return (
        <>
            <div className="blog-cards">
                {currentItems.map((post) => {
                    return (
                        <>
                            <div class="blog-card__list-item">
                                <a class="blog-card" href={post.permalink}>
                                    <img class="blog-card__image" src={post.image} />
                                    <h6 class="blog-card__name">{post.title}</h6>
                                    {/* 
                                    <p class="innear-card__description">
                                        <span class="innear-card__link">อ่านเพิ่มเติม</span>
                                    </p>
                                     */}
                                </a>
                            </div>
                        </>
                    );        
                })} 
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                pageLinkClassName="page-num"
                previousLinkClassName="page-num"
                nextLinkClassName="page-num"
                activeLinkClassName="active"
            />
        </>
    );

}
export default Post
